import { MemberModel } from 'generated-types/member';
import { useNavigate } from 'react-router-dom';
import { SelectPicker } from 'rsuite';

interface InternalUserSelectProps {
    skillsSelected: boolean;
    certificationsSelected: boolean;
    members: MemberModel[];
    user: MemberModel | undefined;
    previewMode: boolean;
    selectedMemberId: number | undefined;
    setSelectedMemberId: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const InternalUserSelect: React.FC<InternalUserSelectProps> = ({
    skillsSelected,
    members,
    user,
    previewMode,
    certificationsSelected,
    selectedMemberId,
    setSelectedMemberId,
}) => {
    const navigate = useNavigate();

    return (
        <SelectPicker
            disabled={skillsSelected || certificationsSelected}
            label="View as"
            placeholder="Select a member"
            value={selectedMemberId ? selectedMemberId : null}
            data={members
                .filter(member => member.id !== user?.id)
                .map(m => {
                    return {
                        value: m.id,
                        label: `${m.lastname} ${m.firstname} `,
                    };
                })}
            onChange={value => {
                if (value) {
                    setSelectedMemberId(value);
                    navigate(previewMode ? `/resume/${value}/preview` : `/resume/${value}`);
                } else {
                    navigate(previewMode ? `/resume/preview` : `/resume`);
                }
            }}
            style={{ width: 300 }}
        />
    );
};

export default InternalUserSelect;
